<template>
    <div class="cont-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('chongbi.xzbz')}}</div>
        </div>
        <ul class="select-box">
           <li class="select" v-for="(item,index) in bzData" :key="index" @click="select(item.name)">
                <img class="icon" :src="item.icon" alt="">
                <div class="t1">{{item.name}}</div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'selectBz',
    data () {
        return {
            uid: '',
            token: '',
            curIdx: 0,
            bzData: [],
            type: 1
        }
    },
    created(){
       this.token = localStorage.getItem('token');
    },
    mounted(){
        this.getmarketList();
    },
    methods: {
        getmarketList(){
           let params = {
               id: 1
           }
           this.$ajax.get('/web/getCurrency',{params}).then((res) => {
                let resData = res.data.data;
                this.bzData = resData;
            }).catch(function(err){
                console.log(err)
            })
       },
      select(bz,idx){
        this.curIdx = idx;
        localStorage.setItem('tbBzName',bz);
        this.$router.push('/withdraw')
      },
        goBack(){
            this.$router.go(-1);
        },
    }
}
</script>
<style scoped>
    .cont-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .32rem;
        height: .6rem;
        transform: translateY(-50%);
    }
    .select-box{
      display: block!important;
      padding: 1.4rem .3rem 0;
    }
    .select-box .select{
        display: flex;
        align-items: center;
        width: 100%;
        margin-top: .42rem;
        padding-bottom: .28rem;
        color: #fff;
        font-size: .42rem;
        border-bottom: 1px solid #313a47;
    }
    .select-box .select:last-child{
        border-bottom: 1px solid #313a47;
    }
    .select-box .select .icon{
        width: .8rem;
        height: .8rem;
        margin-right: .3rem;
    }
    .select-box .select .t1{
        flex: 1;
        color: #fff;
        font-size: .5rem;
    }
    .select-box .select .t2{
        flex: 1;
        padding-right: .4rem;
        color: #fff;
        font-size: .36rem;
        text-align: right;
    }
    .select-box .select.active .arrow{
        width: .42rem;
        height: .22rem;
        border-left: 2px solid #2CAADE;
        border-bottom: 2px solid #2CAADE;
        transform: rotate(-60deg);
    }
</style>



// WEBPACK FOOTER //
// src/pages/selectBz.vue